module.exports = __webpack_public_path__ + "img/tw.tw39308d8.svg";